import { Component, OnDestroy, OnInit } from '@angular/core';
import { redirectToAccount } from '@app/shared/helpers/location';
import { Team } from '@app/shared/models/team';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import * as fromRoot from '../../reducers/index';
import { SEOService } from '@app/core/services/seo.service';
import { ResolveTeamsService } from '@app/core/services/resolvers/resolve-teams.service';

@Component({
  selector: 'app-files-expired',
  templateUrl: './files-expired.component.html',
  styleUrls: ['./files-expired.component.scss']
})
export class FilesExpiredComponent implements OnInit, OnDestroy {
  hasToken$: Observable<boolean>;
  selectedTeam$: Observable<Team>;
  subscriptions: Subscription[] = [];
  isLoggedIn: boolean;
  selectedTeam: Team;

  constructor(
    private readonly store$: Store<fromRoot.State>,
    private resolveTeamsService: ResolveTeamsService,
    private seoService: SEOService
  ) {
    this.hasToken$ = this.store$.select(fromRoot.getHasToken);
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.resolveTeamsService.resolve().subscribe((res) => {
        this.isLoggedIn = res.isLoggedIn;
        this.selectedTeam = res.selectedTeam;
      }),
    );
    // Seo
    this.seoService.removeHreflang();
  }

  redirectToAccount() {
    redirectToAccount(this.selectedTeam.id)
  }

  ngOnDestroy(): void {
    this.subscriptions.map(subscription => subscription.unsubscribe());
  }

}
